// Single source of truth for runtime config. Reads from import.meta.env
// (Vite injects VITE_* values at build time) so the same bundle can be
// promoted across environments by swapping .env files.
//
// Anything exported from this file is also re-published on window.AUTH_CONFIG
// for backwards compat with the script-tag era of the app.

const SITE_URL =
  import.meta.env.VITE_SITE_URL?.replace(/\/$/, "") || window.location.origin;
const API_BASE =
  import.meta.env.VITE_API_BASE?.replace(/\/$/, "") || "http://localhost:5001";

const PROD_CLERK_PUBLISHABLE_KEY = "pk_live_Y2xlcmsuY29tbXVuaXR5bmluamEuYWkk";
const PROD_CLERK_SCRIPT_URL =
  "https://clerk.communityninja.ai/npm/@clerk/clerk-js@5/dist/clerk.browser.js";

const DEV_CLERK_PUBLISHABLE_KEY =
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ||
  "pk_test_ZXhjaXRlZC1nZWxkaW5nLTMwLmNsZXJrLmFjY291bnRzLmRldiQ";
const DEV_CLERK_SCRIPT_URL =
  import.meta.env.VITE_CLERK_SCRIPT_URL ||
  "https://excited-gelding-30.clerk.accounts.dev/npm/@clerk/clerk-js@5/dist/clerk.browser.js";

const hostname = window.location.hostname;
const isProductionClerkHost =
  hostname === "communityninja.ai" || hostname.endsWith(".communityninja.ai");

const CLERK_PUBLISHABLE_KEY = isProductionClerkHost
  ? PROD_CLERK_PUBLISHABLE_KEY
  : DEV_CLERK_PUBLISHABLE_KEY;
const CLERK_SCRIPT_URL = isProductionClerkHost
  ? PROD_CLERK_SCRIPT_URL
  : DEV_CLERK_SCRIPT_URL;

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export const config = {
  siteUrl: SITE_URL,
  apiBase: API_BASE,
  clerk: {
    publishableKey: CLERK_PUBLISHABLE_KEY,
    scriptUrl: CLERK_SCRIPT_URL,
  },
  supabase: {
    url: SUPABASE_URL,
    anonKey: SUPABASE_ANON_KEY,
  },
};

// Legacy global, still consumed by the Clerk + Supabase bootstrap files.
window.AUTH_CONFIG = {
  clerk: config.clerk,
  supabase: config.supabase,
};

// Used by api.jsx to override its default localhost base in production.
window.__API_BASE__ = config.apiBase;

export default config;
